import { createRouter, createWebHistory } from 'vue-router';
import { nextTick } from 'vue';
import MobileDetect from 'mobile-detect';
import store from '../store';
import axios from '../plugins/axios';

// 디바이스 Detect
const md = new MobileDetect(window.navigator.userAgent);
const layoutType = md.mobile() ? 'mobile' : 'desktop';

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => (layoutType === 'desktop' ? import('@/views/MainPage.vue') : import('@/views/MobileMainPage.vue')),
    meta: {
      layout: layoutType,
      authRequired: false,
      title: '동행복권',
    },
  },
  {
    path: '/common.do',
    name: 'Main2',
    component: () => (layoutType === 'desktop' ? import('@/views/MainPage.vue') : import('@/views/MobileMainPage.vue')),
    meta: {
      layout: layoutType,
      authRequired: false,
      title: '동행복권',
    },
  },
  {
    path: '/sports/:scope/:kind?/:league?',
    name: 'Sports',
    component: () => (layoutType === 'desktop' ? import('@/views/sports/SportsList.vue') : import('@/views/sports/SportsList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '스포츠',
    },
  },
  {
    path: '/casino/live',
    name: 'LiveCasino',
    component: () => (layoutType === 'desktop' ? import('@/views/casino/LiveCasino.vue') : import('@/views/casino/MobileLiveCasino.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '라이브카지노',
    },
  },
  {
    path: '/casino/slots',
    name: 'SlotGame',
    component: () => (layoutType === 'desktop' ? import('@/views/casino/SlotGame.vue') : import('@/views/casino/MobileSlotGame.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '슬롯게임',
    },
  },
  {
    path: '/minigame/:type?',
    name: 'MiniGame',
    component: () => (layoutType === 'desktop' ? import('@/views/minigame/MiniGame.vue') : import('@/views/minigame/MobileMiniGame.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '미니게임',
    },
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => (layoutType === 'desktop' ? import('@/views/board/List.vue') : import('@/views/board/MobileList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '공지사항',
    },
  },
  {
    path: '/notice/:idx',
    name: 'NoticeView',
    component: () => (layoutType === 'desktop' ? import('@/views/board/View.vue') : import('@/views/board/MobileView.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '공지/규정',
    },
  },
  {
    path: '/event',
    name: 'Event',
    component: () => (layoutType === 'desktop' ? import('@/views/board/List.vue') : import('@/views/board/MobileList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '이벤트',
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => (layoutType === 'desktop' ? import('@/views/board/List.vue') : import('@/views/board/MobileList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '이용규정',
    },
  },
  {
    path: '/event/:idx',
    name: 'EventView',
    component: () => (layoutType === 'desktop' ? import('@/views/board/View.vue') : import('@/views/board/MobileView.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '이벤트',
    },
  },
  {
    path: '/terms/:idx',
    name: 'TermsView',
    component: () => (layoutType === 'desktop' ? import('@/views/board/View.vue') : import('@/views/board/MobileView.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '이용규정',
    },
  },
  {
    path: '/transaction/deposit',
    name: 'Deposit',
    component: () => (layoutType === 'desktop' ? import('@/views/transaction/Deposit.vue') : import('@/views/transaction/MobileDeposit.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '입금',
    },
  },
  {
    path: '/transaction/withdrawal',
    name: 'Withdrawal',
    component: () => (layoutType === 'desktop' ? import('@/views/transaction/Withdrawal.vue') : import('@/views/transaction/MobileWithdrawal.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '출금',
    },
  },
  {
    path: '/cs',
    name: 'Cs',
    component: () => (layoutType === 'desktop' ? import('@/views/cs/CsList.vue') : import('@/views/cs/MobileCsList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '고객센터',
    },
  },
  {
    path: '/cs/write',
    name: 'CsWrite',
    component: () => (layoutType === 'desktop' ? import('@/views/cs/CsWrite.vue') : import('@/views/cs/MobileCsWrite.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '문의작성',
    },
  },
  {
    path: '/cs/view/:idx',
    name: 'CsView',
    component: () => (layoutType === 'desktop' ? import('@/views/cs/CsView.vue') : import('@/views/cs/MobileCsView.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '고객센터',
    },
  },
  {
    path: '/message',
    name: 'Message',
    component: () => (layoutType === 'desktop' ? import('@/views/message/MessageList.vue') : import('@/views/message/MessageList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '쪽지함',
    },
  },
  // 마이페이지
  {
    path: '/userSsl.do',
    name: 'MyPage',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/MyPageDhb.vue') : import('@/views/_dhb/mobile/MyPageDhb.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '마이페이지 홈 < 마이페이지 | 동행복권',
    },
  },
  {
    path: '/counsel.do',
    name: 'Counsel',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/Counsel.vue') : import('@/views/_dhb/mobile/Counsel.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '1:1상담 < 고객센터 | 동행복권',
    },
  },
  {
    path: '/mypage.do',
    name: 'lottoBuyListView',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/History.vue') : import('@/views/_dhb/mobile/History.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '구매당첨내역 < 구매/당첨 < 마이페이지 | 동행복권',
    },
  },
  {
    path: '/payment.do',
    name: 'Payment',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/Payment.vue') : import('@/views/_dhb/mobile/Payment.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '충전하기 < 예치금 < 마이페이지 | 동행복권',
    },
  },
  {
    path: '/service.do',
    name: 'BoardList',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/BoardList.vue') : import('@/views/_dhb/mobile/BoardList.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '공지사항 < 홍보센터 < 행복공감 | 동행복권',
    },
  },
  {
    path: '/lottoControl.do',
    name: 'Powerball',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/Powerball.vue') : import('@/views/_dhb/mobile/Powerball.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '파워볼 | 동행복권',
    },
  },
  {
    path: '/game/TotalGame.jsp',
    name: 'Game645',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/Game645.vue') : import('@/views/_dhb/mobile/Game645.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '동행복권',
    },
  },
  {
    path: '/game/TotalGame/history',
    name: 'Game645History',
    component: () => (layoutType === 'desktop' ? import('@/views/_dhb/desktop/Popup645.vue') : import('@/views/_dhb/desktop/Popup645.vue')),
    meta: {
      layout: 'empty',
      authRequired: true,
      title: '로또6/45 구매번호 확인 < 구매/당첨 < 마이페이지 | 동행복권',
    },
  },
  {
    path: '/mypage',
    name: 'MyPage2',
    component: () => (layoutType === 'desktop' ? import('@/views/mypage/MyPage.vue') : import('@/views/mypage/MobileMyPage.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '마이페이지',
    },
  },
  {
    path: '/mypage/roulette',
    name: 'Roulette',
    component: () => (layoutType === 'desktop' ? import('@/views/mypage/Roulette.vue') : import('@/views/mypage/MobileRoulette.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '룰렛게임',
    },
  },
  {
    path: '/mypage/attendance',
    name: 'Attendance',
    component: () => (layoutType === 'desktop' ? import('@/views/mypage/Attendance.vue') : import('@/views/mypage/MobileAttendance.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '출석현황',
    },
  },
  {
    path: '/mypage/history',
    name: 'BetHistory',
    component: () => (layoutType === 'desktop' ? import('@/views/mypage/BetHistory.vue') : import('@/views/mypage/MobileBetHistory.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '배팅내역',
    },
  },
  {
    path: '/result',
    name: 'Result',
    component: () => (layoutType === 'desktop' ? import('@/views/result/Result.vue') : import('@/views/result/MobileResult.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '경기결과',
    },
  },
  {
    path: '/live',
    name: 'LiveVideo',
    component: () => (layoutType === 'desktop' ? import('@/views/sports/LiveVideo.vue') : import('@/views/sports/MobileLiveVideo.vue')),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '실시간중계',
    },
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('@/views/partner/Dashboard.vue'),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '파트너',
    },
  },
  {
    path: '/partner/member/:type?',
    name: 'PartnerMember',
    component: () => import('@/views/partner/Dashboard.vue'),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '회원관리',
    },
  },
  {
    path: '/partner/transaction/:type',
    name: 'PartnerTransaction',
    component: () => import('@/views/partner/Dashboard.vue'),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '입출금관리',
    },
  },
  {
    path: '/partner/transaction/shop/:type',
    name: 'PartnerShopTransaction',
    component: () => import('@/views/partner/Dashboard.vue'),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '지급/회수관리',
    },
  },
  {
    path: '/partner/betting/:type?',
    name: 'PartnerBetting',
    component: () => import('@/views/partner/Dashboard.vue'),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '배팅관리',
    },
  },
  {
    path: '/partner/calculate/:type?',
    name: 'PartnerCalculate',
    component: () => import('@/views/partner/Dashboard.vue'),
    meta: {
      layout: layoutType,
      authRequired: true,
      title: '정산관리',
    },
  },
  // Auth
  // {
  //   path: '/auth/login',
  //   name: 'Login',
  //   component: () => (layoutType === 'desktop' ? import('@/views/auth/Login.vue') : import('@/views/auth/Login.vue')),
  //   meta: {
  //     layout: 'auth',
  //     authRequired: false,
  //     title: '로그인',
  //   },
  // },
  // {
  //   path: '/auth/register',
  //   name: 'Register',
  //   component: () => (layoutType === 'desktop' ? import('@/views/auth/Register.vue') : import('@/views/auth/Register.vue')),
  //   meta: {
  //     layout: 'auth',
  //     authRequired: false,
  //     title: '회원가입',
  //   },
  // },
  {
    path: '/user.do',
    name: 'Login',
    component: () => (layoutType === 'desktop' ? import('@/views/auth/Login.vue') : import('@/views/auth/Login.vue')),
    meta: {
      layout: layoutType,
      authRequired: false,
      title: '로그인',
    },
  },
  {
    path: '/loginJoin.do',
    name: 'Register',
    component: () => (layoutType === 'desktop' ? import('@/views/auth/Register.vue') : import('@/views/auth/Register.vue')),
    meta: {
      layout: layoutType,
      authRequired: false,
      title: '회원가입 < 회원서비스 | 동행복권',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior(to, from, savedPosition) {
    const el = document.querySelector('.content');
    if (el) el.scrollTop = 0;
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // if (to.name === 'MiniGame') {
  //   if (store.state.locale === 'ko') alert('점검중입니다.');
  //   if (store.state.locale === 'en') alert('under maintenance.');
  //   if (store.state.locale === 'cn') alert('正在维修.');
  //   if (store.state.locale === 'vn') alert('đang bảo trì.');

  //   next(from.fullPath);
  // }
  if (to.meta.authRequired) {
    axios.get('/web/config/site').then((res) => {
      if (res) {
        store.dispatch('setSiteConfig', res.data);

        if (res.data.isc_is_open_sports === 0 && to.name === 'Sports') {
          return next('/');
        } else if (res.data.isc_is_open_casino === 0 && to.name === 'LiveCasino') {
          return next('/');
        } else if (res.data.isc_is_open_slot === 0 && to.name === 'SlotGame') {
          return next('/');
        } else if (res.data.isc_is_open_mini === 0 && to.name === 'MiniGame') {
          return next('/');
        } else if (res.data.isc_is_open_mini === 0 && to.name === 'Powerball') {
          alert('점검중입니다.');
          return next('/');
        }

        const isAuthenticated = store.getters.isAuthenticated;
        // 인증이 필요한 페이지일 경우 인증 체크
        if (isAuthenticated) {
          next(); // 페이지 전환
        } else {
          next('/user.do?method=login');
        }
      }
    });
  } else {
    next(); // 페이지 전환
  }
});

router.afterEach((to, from) => {
  // nextTick은 Dom이 업데이트 된 후 실행됩니다.
  nextTick(() => {
    if (to.query.method === 'depositListView') to.meta.title = '예치금 충전 내역 < 예치금 < 마이페이지 | 동행복권';
    if (to.query.method === 'refundView') to.meta.title = '출금 신청 < 예치금 < 마이페이지 | 동행복권';
    if (to.query.method === 'payment') to.meta.title = '충전하기 < 예치금 < 마이페이지 | 동행복권';
    if (to.query.method === 'eventList') to.meta.title = '이벤트 < 홍보센터 < 행복공감 | 동행복권';

    document.title = to.meta.title;
  });
});

export default router;
